<template>
  <div  class="modal fade" id="modalDetailProdCondMagInv" ref="modalDetailProdCondMagInvRef" role="dialog"
   tabindex="-1" aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="tooltipmodal">Details de {{ product.nomProd.split("-")[0] }}</h4>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <h2 class="text-center">{{ product.nomProd }}</h2>
            <table class="table table-responsive-sm">
              <tbody>
                <tr>
                  <th class="">Quantité Logique</th>
                  <td>{{ product.qteLogique }}</td>
                </tr>
                <tr>
                  <th class="">Quantité Fiche</th>
                  <td>{{ product.qteFiche }}</td>
                </tr>
                <tr>
                  <th class="">Quantité Mag</th>
                  <td>{{ product.qtePhysique }}</td>
                </tr>
                <tr>
                  <th class="">Ecart Fiche</th>
                  <td>{{ product.ecartFiche }}</td>
                </tr>
                <tr>
                  <th class="">Ecart Logique</th>
                  <td>{{ product.ecartLogique }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" type="button" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, watch, onMounted } from 'vue';

export default {
  name: "ModalDetailProdCondMagInv",
  components: {
  },
  props: {
    item: {
      type: Object as () => any | null,
      default: null
    }
  },
  emits: ['openmodal'],
  setup(props, { emit }) {
    const modalDetailProdCondMagInvRef = ref<null | HTMLElement>(null);
    const product = ref(props.item);
    const isUPDATE = ref(false);
    const item = ref();

    watch(() => props.item, (newValue) => {
      if (newValue != null) { 
        product.value =newValue;
        emit('openmodal', modalDetailProdCondMagInvRef.value);
      }
    });

    onMounted(() => {
      emit('openmodal', modalDetailProdCondMagInvRef.value);
    });

    return {
      modalDetailProdCondMagInvRef,
      item,
      product
    };
  },
};
</script>@/models/CategorieInfo